// store
import { useSearchStore } from "store/searchStore";

// styles
import styles from "./ExportProfileSection.module.scss";

// constants
import { countryNames } from "constants/BusinessProfile";

// components
import DisplayValue from "../DisplayValue";

function mapExporterStatus(status) {
  switch (status) {
    case "W":
      return "Wants to export";
    case "Y":
      return "Is an exporter";
    case "N":
      return "Not an exporter";
    default:
      return null;
  }
}

function splitExporterString(exporterString) {
  return exporterString.split(";").map((item) => item.trim());
}

export default function ExportProfileSection() {
  const { business_profile } = useSearchStore();

  const isNotExporter =
    business_profile?.exporter_status === "N" ||
    !business_profile?.exporter_status;

  return (
    <div className={styles["export-profile-root"]}>
      <h2 className={styles["heading"]} id="export-information" tabIndex={-1}>
        Export information
      </h2>

      <div className={styles["export-content"]}>
        <div className={styles["data-field"]}>
          <h5 className={styles["label"]}>Exporter status</h5>
          <DisplayValue
            messageElement="p"
            className={styles["value"]}
            value={mapExporterStatus(business_profile?.exporter_status)}
          />
        </div>

        {!isNotExporter && (
          <>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Export business activities</h5>
              {business_profile?.export_business_activities ? (
                <DisplayValue
                  messageElement={"ul"}
                  className={styles["list"]}
                  value={business_profile?.export_business_activities}
                  renderer={(_value) => (
                    <>
                      {splitExporterString(
                        business_profile.export_business_activities
                      ).map((activity, i) => {
                        return <li key={i}>{activity}</li>;
                      })}
                    </>
                  )}
                />
              ) : (
                <p className={styles["value"]} style={{ fontStyle: "italic" }}>
                  Not Provided
                </p>
              )}
            </div>

            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>
                Desired business relationships
              </h5>
              {business_profile?.desired_export_relationships ? (
                <DisplayValue
                  messageElement="ul"
                  className={styles["list"]}
                  value={business_profile?.desired_export_relationships}
                  renderer={(_value) => (
                    <>
                      {splitExporterString(
                        business_profile.desired_export_relationships
                      ).map((relationship, i) => {
                        return <li key={i}>{relationship}</li>;
                      })}
                    </>
                  )}
                />
              ) : (
                <p className={styles["value"]} style={{ fontStyle: "italic" }}>
                  Not Provided
                </p>
              )}
            </div>

            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Exporting to (countries)</h5>
              {business_profile?.export_to ? (
                <DisplayValue
                  messageElement="ul"
                  className={styles["list"]}
                  value={business_profile?.export_to}
                  renderer={(_value) => (
                    <>
                      {splitExporterString(business_profile.export_to).map(
                        (country, i) => {
                          return <li key={i}>{countryNames[country]}</li>;
                        }
                      )}
                    </>
                  )}
                />
              ) : (
                <p className={styles["value"]} style={{ fontStyle: "italic" }}>
                  Not Provided
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
